const styles = () => ({
  divWidth: {
    width: '100%',
  },
});

export default styles;
